export default {
    dialogTitle: {
        edit: '编辑角色',
        add: '新建角色',
        delete: '删除角色',
        detail: '角色详情',
    },
    button: {
        addRole: '新增角色',
        addAdminRole: '新增管理员角色',
        search: '查询',
        detail: '详情',
        edit: '编辑',
        delete: '删除',
        cancel: '取消',
        confirm: '确定',
    },
    text: {
        accountList: '使用角色账号列表',
        inputTips: '请输入',
        inputTipsName: '请输入角色名',
        inputTipsDesc: '请输入角色介绍',
        title: '角色管理',
        operateDetail: '操作记录',
        detail: '详情',
        confirmMsg1: '角色下有',
        confirmMsg2: '个账号无法删除',
        confirmMsg3: '是否删除',
        confirmMsg4: '的角色?',
    },
    label: {
        selectSys: '请选择系统',
        roleName: '角色名:',
        roleDesc: '角色介绍:',
        roleAuth: '角色权限:',
    },
    table: {
        index: '序号',
        roleName: '角色名',
        roleDesc: '角色介绍',
        createTime: '创建时间',
        account: '使用账号数',
        operate: '操作',
        phone: '手机号',
        userName: '姓名',
        status: '状态',
        operateContent: '操作类型',
        operater: '操作人',
        operateTime: '操作时间',
        operateDetail: '操作详情',
    },
    validate: {
        name: '请输入角色名',
        description: '请输入角色介绍',
    },
};
